module.exports = __webpack_public_path__ + "static/media/orange-exclamation.4339df4a.svg";